import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { createColumnHelper, useTable } from "@components/mantine";
import { Platform, useQuery } from "@core/api";
import { GenericGranularPrivilegesTable } from "../GenericGranularPrivilegesTable.js";
import { Locales } from "../../../../strings/Locales.js";
var columnHelper = createColumnHelper();
var columns = [
    columnHelper.accessor("name", {
        header: Locales.format("PrivilegesTable.SecurityProviders.column.name.header"),
        enableSorting: false
    })
];
var selectOptions = {
    disabled: {
        value: "NONE",
        label: Locales.format("AccessLevelPicker.option.DENY")
    },
    enabled: {
        value: "ALLOW",
        label: Locales.format("AccessLevelPicker.option.ALLOW")
    }
};
export var SecurityProvidersPushPrivilegesTable = function(props) {
    var store = useTable();
    var query = useQuery({
        queryKey: [
            "securityCache",
            "listProviders"
        ],
        queryFn: /*#__PURE__*/ _async_to_generator(function() {
            var response;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            Platform.securityCache.listProviders()
                        ];
                    case 1:
                        response = _state.sent();
                        store.setTotalEntries(response.length);
                        return [
                            2,
                            response
                        ];
                }
            });
        })
    });
    return /*#__PURE__*/ _jsx(GenericGranularPrivilegesTable, _object_spread({
        store: store,
        columns: columns,
        query: query,
        resourceName: props.name.toLowerCase(),
        options: selectOptions
    }, props));
};

//# sourceMappingURL=SecurityProvidersPushPrivilegesTable.js.map